const styles = () => ({
  root: {
    minHeight: 80,
  },
})

export default styles
